import type { FormEvent } from 'react'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import HotelSearchForm from 'components/Search/Hotels/HotelSearchForm'
import { useGlobalHotelsSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHotelsSearch'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import config from 'constants/config'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import HotelsTabContent from 'components/SearchV2/Components/Mobile/TabContents/HotelsTabContent'
import useGlobalSearchVerticalTabBooking from 'components/SearchV2/Hooks/useGlobalSearchVerticalTabBooking'
import { HOTEL_SEARCH_TYPEAHEAD_TYPES } from 'constants/search'

function GlobalHotelsSearchTabContent() {
  const intl = useIntl()

  const { globalHotelsSearchDispatch, globalHotelsSearchState } = useGlobalHotelsSearchContext(GLOBAL_SEARCH_INITIAL_STATE)
  const formRef = useRef<HTMLFormElement>(null)
  const temporarySearchSubmitRef = useRef<App.TypeaheadSubmitRefData | null>(null)

  const { onSearch, updateSearchSessionId } = useGlobalSearchVerticalTabBooking({
    globalSearchDispatch: globalHotelsSearchDispatch,
    globalSearchState: globalHotelsSearchState,
    temporarySearchSubmitRef,
    enableTypeaheadSubmit: true,
    typeaheadTypes: HOTEL_SEARCH_TYPEAHEAD_TYPES,
  })

  const handleSearch = () => {
    if (formRef.current?.reportValidity()) {
      onSearch()
    }
  }

  const onSearchSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleSearch()
  }

  const searchButtonText = intl.formatMessage({
    id: 'NlUtVRbkXOmpSFkheT4Z',
    defaultMessage: 'Search',
    description: 'Search button text for global hotels search on the hotel page',
  })

  return <GlobalSearchContextProvider
    state={globalHotelsSearchState}
    dispatch={globalHotelsSearchDispatch}
  >
    {!config.USE_INSPIRATIONAL_SEARCH &&
      <CSSBreakpoint max="mobile">
        <VerticalSpacer as="form" onSubmit={onSearchSubmit} gap={12} ref={formRef}>
          <HotelsTabContent
            isInPage
            onSearch={handleSearch}
            temporarySearchSubmitRef={temporarySearchSubmitRef}
            updateSearchSessionId={updateSearchSessionId}
          />
          <TextButton fit="mobile-full-width" kind="primary" type="submit" size="large">{searchButtonText}</TextButton>
        </VerticalSpacer>
      </CSSBreakpoint>}
    <CSSBreakpoint min="tablet">
      <HotelSearchForm submitOnApply />
    </CSSBreakpoint>
  </GlobalSearchContextProvider>
}

export default GlobalHotelsSearchTabContent
